// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"aab44c2d","856":"50d801ad","860":"ca1fc792"}[chunkId] + ".js";
};